export default {
  labels: {
    google_place: 'Miejsce Google',
    menu_import: 'Import menu',
    live: 'Na żywo',
    setting_up: 'Konfiguracja',
  },
  buttons: {
    confirm: 'Potwierdź',
    cancel: 'Anuluj',
    continue_setup: 'Kontynuuj konfigurację',
  },
  delete_confirmation: 'Czy na pewno?',
};
